import * as yup from 'yup'

import { VerifyEmailCodeFields } from './verifyEmailCode.types'

export const verifyEmailCodeSchema = yup.object().shape({
    [VerifyEmailCodeFields.verificationCode]: yup.string().length(6).required('AUTH.REQUIRED_FIELD'),
    [VerifyEmailCodeFields.trustedDevice]: yup.boolean(),
})
